module.exports = __webpack_public_path__ + "static/media/FilmGob.45cd8cfc.jpg";